export function formatDistanceKm(latA: number, lngA: number, latB: number, lngB: number): string {
  const toRad = (v: number) => (v * Math.PI) / 180;
  const r = 6371;
  const dLat = toRad(latB - latA);
  const dLng = toRad(lngB - lngA);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(latA)) * Math.cos(toRad(latB)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return `${(r * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))).toFixed(1)} km`;
}

export function unitTypeLabel(buildingType: string): string {
  const key = String(buildingType || '').toLowerCase();
  if (key === 'pompier') return 'Incendie';
  if (key === 'hopital') return 'Secours à personne';
  if (key === 'fdo') return 'Police';
  if (key === 'prison') return 'Sécurité';
  if (key === 'cta') return 'Commandement';
  return 'Multirôle';
}

export function isCtaBuildingType(buildingType: string | undefined): boolean {
  return String(buildingType || '').trim().toLowerCase() === 'cta';
}

export function vehicleStateLabel(
  statut: string | undefined,
): 'PRÊT' | 'EN MISSION' | 'MAINTENANCE' | 'INDISPONIBLE' {
  const s = String(statut || '').toLowerCase();
  if (s === 'disponible') return 'PRÊT';
  if (s === 'en_mission') return 'EN MISSION';
  if (s === 'en_maintenance') return 'MAINTENANCE';
  return 'INDISPONIBLE';
}

export function defaultPriorityForPhase(phase: string): number {
  if (phase === 'wait') return 1;
  if (phase === 'travel') return 2;
  return 3;
}

export function interventionPhaseLabel(phase: string): string {
  if (phase === 'wait') return 'En attente';
  if (phase === 'travel') return 'En transit';
  if (phase === 'site') return 'Sur site';
  return 'En cours';
}

export function interventionPhaseClass(phase: string): string {
  if (phase === 'wait') return 'border-red-500/40 bg-red-950/25 text-red-200';
  if (phase === 'travel') return 'border-amber-500/40 bg-amber-950/25 text-amber-200';
  if (phase === 'site') return 'border-emerald-500/40 bg-emerald-950/25 text-emerald-200';
  return 'border-slate-500/40 bg-slate-950/25 text-slate-200';
}

export type MainMapView = 'dispatch' | 'resources' | 'buildings' | 'interventions';

export function normalizeMainMapView(rawView: string | null): MainMapView {
  if (rawView === 'resources') return 'resources';
  if (rawView === 'buildings') return 'buildings';
  if (rawView === 'interventions') return 'interventions';
  return 'dispatch';
}
